import getConfig from 'next/config';

import { initializeApp } from 'firebase/app';

const { publicRuntimeConfig } = getConfig();

const isProd = publicRuntimeConfig.environment === 'prod';
const env = isProd ? 'prod' : 'non-prod';

const firebaseConfig = {
    apiKey: publicRuntimeConfig.FCM_CONFIG_KEY,
    authDomain: `web-push-notification-${env}.firebaseapp.com`,
    projectId: `web-push-notification-${env}`,
    storageBucket: `web-push-notification-${env}.firebasestorage.app`,
    messagingSenderId: isProd ? '733000158197' : '433580226963',
    appId: isProd ? '1:733000158197:web:ca5aaa2adb4f386983aebc' : '1:433580226963:web:88d0ad0bb240bae2b35066',
    measurementId: isProd ? 'G-6MF5ZX8VEK' : 'G-SH14JMVL1S',
};

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
